import { render, staticRenderFns } from "./zixunList.vue?vue&type=template&id=2525c00b&scoped=true"
import script from "./zixunList.vue?vue&type=script&lang=js"
export * from "./zixunList.vue?vue&type=script&lang=js"
import style0 from "./zixunList.vue?vue&type=style&index=0&id=2525c00b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2525c00b",
  null
  
)

export default component.exports